import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import { useState } from "react";
import Users from "./pages/Users";
import Drivers from "./pages/Drivers";
import DashboardLayout from "./layout/DashboardLayout";
import VehicleCharges from "./pages/VehicleCharges";
import AllTrips from "./pages/AllTrips";
import DriverWithdrawals from "./pages/DriverWithdrawals";
import CancelRide from "./pages/CancelRide";
import DeleteAccount from "./pages/DeleteAccount";
import Home from "./pages/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import PendingRides from "./pages/PendingRides";




function App() {
  const [, setIsLoggedIn] = useState(localStorage.getItem("loggedIn") === "true");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

        <Route element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/drivers" element={<Drivers />} />
          <Route path="/VehicleCharges" element={<VehicleCharges />} />
          <Route path="/AllTrips" element={<AllTrips />} />
          <Route path="/DriverWithdrawals" element={<DriverWithdrawals />} />
          <Route path="/CancelRide" element={<CancelRide />} />
          <Route path="/PendingRides" element={<PendingRides />} />
        </Route>
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
